

















import Vue from 'vue';

export default Vue.extend({
  name: 'PageLevelLoader',
  data: () => ({
    shown: false
  }),
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hideDelay: {
      type: Number,
      default: 500
    },
    secondary: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    calcVisible(val: boolean) {
      if (val === false) {
        (this.$options as any).timeout = setTimeout(() => {
          this.shown = val;
        }, this.hideDelay);
      } else {
        clearTimeout((this.$options as any).timeout);
        this.shown = val;
      }
    }
  },
  watch: {
    visible(val: boolean) {
      this.calcVisible(val);
    }
  },
  mounted() {
    this.calcVisible(this.visible);
  }
});
